//import React from "react";
import { useState } from "react";
import { useTable, /*useFilters, */useSortBy, useGlobalFilter } from "react-table";

export default function MagicTable({ title, columns, data }) {

	// Use the useTable Hook to send the columns and data to build the table
	const {
		getTableProps, // table props from react-table
		getTableBodyProps, // table body props from react-table
		headerGroups, // headerGroups, if your table has groupings
		rows, // rows for the table based on the data passed
		prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
		setGlobalFilter
	} = useTable({
		columns,
		data
	}, useGlobalFilter, useSortBy);

	const [filterInput, setFilterInput] = useState("");

	const handleFilterChange = e => {
		const value = e.target.value || undefined;
		setGlobalFilter(value); // Update the show.name filter. Now our table will filter and show only the rows which have a matching value
		setFilterInput(value);
	};

  /* 
    Render the UI for your table
    - react-table doesn't have UI, it's headless. We just need to put the react-table props from the Hooks, and it will do its magic automatically
  */
	return (
		<div>
			<h3>{title}</h3>
			<table className={"magicTable"}  {...getTableProps()}>
				<thead>
					{headerGroups.map(headerGroup => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map(column => (
								<th {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render("Header")}</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{rows.map((row) => {
						prepareRow(row);
						return (
							<tr {...row.getRowProps()}>
								{row.cells.map(cell => {
									return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
								})}
							</tr>
						);
					})}
				</tbody>
			</table>
			<br />
			<input
				value={filterInput}
				onChange={handleFilterChange}
				placeholder={"Search"}
			/>

		</div>
	);
}